// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-avatar {\n  justify-content: center !important;\n}\n.v-list-item--three-line .v-list-item__avatar {\n  align-self: center !important;\n}", ""]);
// Exports
module.exports = exports;
